// Unpublished Work © 2026 Deere & Company.

function assignLocation(url) {
    window.location.assign(url);
}

function replaceLocation(url) {
    window.location.replace(url);
}

function getLocationHref() {
    return window.location.href;
}

function getLocationHostname() {
    return window.location.hostname;
}

export {
    assignLocation,
    replaceLocation,
    getLocationHref,
    getLocationHostname
};
